import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from "ramda"
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectDbaRegistriesQueryItems } from '../../../../../redux/dba-registries/selector';
import { selectDbnpListItems } from '../../../../../redux/dbnp/selector';
import { selectOpennetworkDomainsListItems } from '../../../../../redux/opennetwork-domains/selector';
import storePersist from '../../../../../redux/storePersist';
import { dbaRegistries } from '../../../../../redux/dba-registries/action';
import { dbnp } from '../../../../../redux/dbnp/action';
import { opennetworkDomains } from '../../../../../redux/opennetwork-domains/action';
import PageLoader from '../../../../../components/PageLoader';
import DBARegistryDetails from '../components/shipx-registry-details';

const ShipXRegistry = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const dbnpRegistriesQuery = useSelector(selectDbaRegistriesQueryItems)
    const dpnpNameLists = useSelector(selectDbnpListItems)
    const openNetworkDomainNameLists = useSelector(selectOpennetworkDomainsListItems)
    const librariesItems = storePersist?.get("library")?.current;
    const countries =  storePersist.get('countries').current?.items;
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [ selectedDbaRegistry, setSelectedDbaRegistry ] = useState<any>({})

    const fetchDbnpRegistryById = () => {
        setIsLoading(true)
        dispatch(dbaRegistries.query({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dod-cloud/dba-registries/query`, 
            entity: 'dbaRegistries', 
            jsonData: {
                Records: [
                    {
                        DBARegistryId: parmas?.id
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
            setIsLoading(false)
        })
    }

    const handleBacicInnerFormChange: any = (event: any, field: string) => {
        setSelectedDbaRegistry({ ...selectedDbaRegistry, [field]: event });
    }
    const handleInnerFormChange: any = (event: any, field: string, data: any) => {
        const fields = R.split(
          '.',
          field
        );
        const value = { ...data, [fields[1]]: event }// inner data update
        setSelectedDbaRegistry({ ...selectedDbaRegistry, [fields[0]]: value });
    }

    useEffect(
        () => {
            dispatch(dbnp.list({ 
                url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbnp/list`, 
                entity: 'dbnp', 
                jsonData: {} 
            })).then(() => {
                dispatch(opennetworkDomains.list({ 
                    url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/dbn-fetch`, 
                    entity: 'opennetworkDomains', 
                    jsonData: { "Context": {},
                    "Records": [
                        {
                            "IsSubDomain": null 
                        }
                    ],
                    "Pagination": {
                      // "PageNumber": pageData,
                      // "PageSize": pageSize,
                      "SortField": "GlobalDBNDomainId",
                      "SortOrder": "desc",
                    }} 
                }))
            }).then(() => {
                if (parmas?.id > 0) {
                    fetchDbnpRegistryById()
                    setIsLoading(false)
                } else {
                    setIsLoading(false)
                }
            })
        },
        []
    )

    const parentDomain = openNetworkDomainNameLists?.result?.items.filter(
        (subDomainData: any) => subDomainData.IsSubDomain === false
    )
    const subDomains = openNetworkDomainNameLists?.result?.items.filter(
        (subDomainData: any) => subDomainData.IsSubDomain === true
    )

    useEffect(
        () => {
            if (isQuery) {
                setSelectedDbaRegistry(dbnpRegistriesQuery?.result?.items)
            }
        },
        [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        if (parmas?.id > 0) {
            await dispatch(dbaRegistries.resetAction({ actionType: 'update' }))
            await dispatch(dbaRegistries.update({
                url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dod-cloud/dba-registries`, 
                entity: 'dbaRegistries', 
                jsonData: {
                    Records: [
                        selectedDbaRegistry
                    ]
                }
            })).then(() => {
                back()
            })
        } else {
            await dispatch(dbaRegistries.resetAction({ actionType: 'create' }))
            await dispatch(dbaRegistries.create({
                url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dod-cloud/dba-registries`, 
                entity: 'dbaRegistries', 
                jsonData: {
                    Records: [
                        selectedDbaRegistry
                    ]
                }
            })).then(() => {
                back()
            })
        }
    }

    const back = () => {
        navigate('/management/shipx-cloud/shipx-agency-registries')
    }
    return (
        <>
            {isLoading ? <PageLoader /> :
                <DBARegistryDetails
                    handleInnerFormChange={handleInnerFormChange}
                    handleBacicInnerFormChange={handleBacicInnerFormChange}
                    selectedDbaRegistry={selectedDbaRegistry}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    id={parmas?.id}
                    dbnpname={dpnpNameLists?.result?.items}
                    opsnumber={librariesItems?.Ops_no}
                    domains={parentDomain}
                    subDomains={subDomains}
                    countries={countries}
                />
            }
        </>
    )

}

export default ShipXRegistry;